export const creditText = (songName: string, videoUrl: string, spotifyUrl: string) =>
  `Music: ${songName ? songName : "[Paste Artist - Track Title]"}` +
  "\n© Provided by Audio Sanctum" +
  `\nWatch: ${videoUrl ? videoUrl : "[Paste link to Audio Sanctum YT video]"}` +
  `\nListen: ${spotifyUrl ? spotifyUrl : "https://spotify.audiosanctum.com"}` +
  "\nBuy: https://sanctum.shop" +
  "\nFree Use → https://audiosanctum.com/free-youtube-music";

/**
 * The short Credit Text for PAID use — a Single YouTube Licence or a
 * Subscription. Free Use pastes the full block above; paid pastes this one
 * line. Must equal the backend `PAID_CREDIT_LINE` (common/utils/credit-text.ts)
 * and the licence certificate's paid attribution block — the string a paid
 * user is told to paste is the exact string the runner searches for.
 */
export const paidCreditLine = "© Music provided by Audio Sanctum";
